import type { AuthContextType } from '@/context/auth-context';
import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
} from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { Toaster } from '@/components/ui/sonner';
import type { QueryClient } from '@tanstack/react-query';
import { Button } from '@/components/ui/button';
import { Link } from '@tanstack/react-router';
import { RouterTrackingWrapper } from '@/components/router-tracking-wrapper';
import { LayoutWrapper } from '@/components/layout/layout-wrapper';

interface MyRouterContext {
  auth: AuthContextType;
  queryClient: QueryClient;
}

function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-900 dark:text-gray-100 mb-4">
          404
        </h1>
        <p className="text-xl text-gray-600 dark:text-gray-400 mb-8">
          Page not found
        </p>
        <Button asChild>
          <Link to="/">Go Home</Link>
        </Button>
      </div>
    </div>
  );
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => (
    <RouterTrackingWrapper>
      <HeadContent />
      <LayoutWrapper>
        <Outlet />
      </LayoutWrapper>
      <Toaster />

      {process.env.NODE_ENV === 'development' && <TanStackRouterDevtools />}
    </RouterTrackingWrapper>
  ),
  notFoundComponent: NotFound,
});
